import {
    onlineCredit,
    selfemloyedBusiness,
    mortgageCommercialBusiness,
} from '@/static/pages/constants/creditRates';
import {CREDIT_FORM_ID} from '@/core/constants/common';

/**
 * core/models/pages/business-page/SelfemployedModel.js
 * core/models/pages/business-page/BusinessModel.js
*/
const onlineCreditSlide = {
    mainSlide: true,
    slideImg: {
        src: 'components/business-page/online-credit2.webp',
        alt: 'Онлайн-кредит без документов',
    },
    slideTitle: {
        title: 'Онлайн-кредит без&nbsp;документов',
    },
    slideValue: {
        value: 'Решение за&nbsp;1&nbsp;день',
    },
    slideLink: '/business/business-crediting/onlain-kredit',
    slideAddition: {
        prefix: 'от',
        rate: onlineCredit.rate,
        postfix: 'годовых',
    },
};

/*
* core/models/pages/business-page/BusinessModel.js
*/

// const rkoCurrency = {
//     slideImg: {
//         src: 'pages/business/rko/benefit6.webp',
//         alt: 'Валютное РКО',
//     },
//     slideTitle: {
//         title: 'Валютное РКО',
//     },
//     slideValue: {
//         value: 'в&nbsp;манатах, китайских юанях <br>и&nbsp;турецких лирах',
//     },
//     slideLink: '/business/opening-and-maintaining-account/rko-currency',
// };

/*
* core/models/pages/business-page/BusinessModel.js
*/

const greenMortgageBusinessSlide = {
    slideImg: {
        src: 'pages/for-individuals/mortgage/green-mortgage-banner-small-biz.png',
        alt: 'Зелёная ипотека для бизнеса',
    },
    slideTitle: {
        title: 'Зелёная ипотека для бизнеса',
    },
    slideValue: {
        value: 'на энергоэффективную недвижимость',
    },
    slideLink: '/business/business-crediting/zelenaia-ipoteka-dlia-biznesa',
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
 * core/models/pages/business-page/BusinessModel.js
*/
const selfemloyedBusinessSlide = {
    slideImg: {
        src: 'components/business-page/credit4.jpg',
        alt: 'Кредит для самозанятых',
    },
    slideTitle: {
        title: 'Кредит для самозанятых',
    },
    slideValue: {
        value: 'на&nbsp;развитие бизнеса',
    },
    slideLink: 'https://www.centrinvest.ru/cabinet/new-creditform/start/?selfjob=1&creditType=1&selfCredtarget=1',
    slideAddition: {
        rate: selfemloyedBusiness.rate,
        postfix: 'годовых',
    },
};

/**
 * core/models/pages/business-page/SelfemployedModel.js
 * core/models/pages/business-page/BusinessModel.js
*/
const mortgageCommercialBusinessSlide = {
    slideImg: {
        src: 'components/business-page/popular3.png',
        alt: 'Коммерческая ипотека',
    },
    slideTitle: {
        title: 'Коммерческая ипотека',
    },
    slideLink: '/business/business-crediting/kommercheskaia-ipoteka',
    slideAddition: {
        prefix: 'от',
        rate: mortgageCommercialBusiness.rate,
        postfix: 'годовых',
    },
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const bankGuaranteesSlide = {
    slideImg: {
        src: 'pages/business/bank-guarantee/banner.webp',
        alt: 'Банковские гарантии',
    },
    slideTitle: {
        title: 'Банковские гарантии',
    },
    slideValue: {
        value: 'Срок получения банковской гарантии&nbsp;&mdash; не&nbsp;более 2-3 рабочих дней',
    },
    slideLink: '/business/bank-guarantees',
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const salaryProjectsSlide = {
    slideImg: {
        src: 'components/business-page/popular2.png',
        alt: 'Зарплатный проект',
    },
    slideTitle: {
        title: 'Зарплатный проект &laquo;Центр-инвест&raquo;',
    },
    slideLink: '/business/salary-projects',
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const acquiringSlide = {
    slideImg: {
        src: 'components/business-page/acquiring-banner.png',
        alt: 'Эквайринг 1% для социально значимых видов деятельности и товаров',
    },
    slideTitle: {
        title: 'Эквайринг 1%',
        additionalClasses: ['profit-propositions-box__title'],
    },
    slideValue: {
        value: 'для социально значимых видов деятельности и&nbsp;товаров',
    },
    slideLink: '/business/acquiring',
    slideAddition: {
        rate: '1',
        postfix: 'годовых',
    },
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const leasingSlide = {
    slideImg: {
        src: 'components/business-page/credit3.png',
        alt: 'Лизинг',
    },
    slideTitle: {
        title: 'Лизинг',
        additionalClasses: ['profit-propositions-box__title_white'],
    },
    slideLink: '/business/leasing',
};

/**
 * core/models/pages/business-page/BusinessModel.js
*/
const checkoutSlide = {
    slideImg: {
        src: 'components/business-page/checkout1.png',
        alt: 'Онлайн-касса с эквайрингом бесплатно',
    },
    slideTitle: {
        title: 'Онлайн-касса с&nbsp;эквайрингом бесплатно',
    },
    slideLink: `/business/acquiring#${CREDIT_FORM_ID}`,
};

/**
 * @/core/models/pages/business-page/BusinessModel.js
*/
const creditHolidaysSlide = {
    slideImg: {
        src: 'pages/business/credit-holidays/credit.jpg',
        alt: 'Кредитные каникулы для бизнеса',
    },
    slideTitle: {
        title: 'Кредитные каникулы для бизнеса',
    },
    slideLink: '/business/credit-holidays',
};

/*
    2/core/models/pages/esg/EsgModel.js
*/
const digitalTransformationSlide = {
    slideImg: {
        src: 'pages/esg/transformation.png',
        alt: 'Трансформация бизнеса',
    },
    slideTitle: {
        title: 'Трансформация бизнеса',
    },
    slideLink: '/business/business-crediting/transformatsiia-biznesa',
};

/*
    @/core/models/pages/esg/EsgModel.js
*/
const womenCreditSlide = {
    slideImg: {
        src: 'pages/esg/flowers.png',
        alt: 'Бизнес-кредит для женщин',
    },
    slideTitle: {
        title: 'Бизнес-кредит для женщин',
    },
    slideLink: '/business/business-crediting/biznes-kredit-dlia-zhenshchin',
};

/*
    @/core/models/pages/esg/EsgModel.js
*/
const socialCreditSlide = {
    slideImg: {
        src: 'pages/esg/doctor.png',
        alt: 'Социальная ответственность',
    },
    slideTitle: {
        title: 'Социальная ответственность',
    },
    slideLink: '/business/business-crediting/sotsialnaia-otvetstvennost',
};

export {
    onlineCreditSlide,
    selfemloyedBusinessSlide,
    mortgageCommercialBusinessSlide,
    bankGuaranteesSlide,
    salaryProjectsSlide,
    acquiringSlide,
    leasingSlide,
    checkoutSlide,
    creditHolidaysSlide,
    greenMortgageBusinessSlide,
    digitalTransformationSlide,
    womenCreditSlide,
    socialCreditSlide,
};
